"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const react_1 = __importDefault(require("react"));
require("./styles.scss");
const Button = (props) => {
    const { type = "primary", size = "small", children, disabled = false, onClick } = props;
    const buttonClasses = `c-button c-button--${type} c-button--${size}`;
    return (react_1.default.createElement("button", { disabled: disabled, onClick: onClick, className: buttonClasses }, children));
};
exports.Button = Button;
